<template>
  <div class="wrapper" style="background-color:#296AE1">
    <div class="banner">
      <img src="../assets/imgs/banner.png" alt="" style="width: 100%">
    </div>
    <div class="listIn item4">
      <div class="list">
        <div class="title" >
         首页> {{tag.tagname}}
        </div>
        <ul>
          <li v-for="(item,index) in this.list" >
            <a :href="item.url" v-if="!isClients"><img :src="item.thumb" alt="">
              <p>{{item.title}}</p>
              <div class="source"><span>{{item.source}}</span><span>{{item.timepoint}}</span></div>
            </a>
            <div v-if="isClients" @click="goCentent(item.contentid,item.appid)" class="a"><img :src="item.thumb" alt="">
              <p>{{item.title}}</p>
              <div class="source"><span>{{item.source}}</span><span>{{item.timepoint}}</span></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <img src="../assets/imgs/bottom.png" alt="">
    </div>
  </div>
</template>

<script>
import {Loading} from "element-ui";

let loading;
const startLoading = () => {
  // 使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: "加载中……",
    background: "rgba(255, 255, 255, 0.7)",
  });
};
startLoading();
import { openapi_get_url } from "../assets/js/Request";
import axios from "axios";
export default {
  name: "list",
  data() {
    return {
      list:[],
      tag:[]
    }
  },
  mounted()  {
    this.isClients = mc.isClient();
    this.getData()
    loading.close();
  },
  methods:{
    goCentent(contentid,appid){
      mc.openContentView({
        "contentid":contentid,
        "appid":appid,
        "siteid":"10001"
      })
    },
    back(){
      this.$router.go(-1);
    },
    getData() {
      const tagId = this.$route.query.id;
      axios(openapi_get_url('special/mobileTag', {
        'content_id': 327839,
        'tagid':tagId,
        'page':1,
        'pagesize':50
      })).then((response) => {
          this.list = response.data.data.list
          this.tag = response.data.data.tag
      });
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/list.vue